import platformDetection from '../../components/utils/PlatformDetection';
import storeManager from '../../store/StoreManager';
import apiService from '../../services/ApiService';
import animationManager from './AnimationManager';
import saveManager from './SaveManager';
import masterUniverseUtils from './MasterUniverseUtils';
import videoUtils from './VideoUtils';

const audioUtils = {
    // PLAY/PAUSE LOGIC START. Sometimes it can take a while for the playback to
    // actually start (Seeking or something?) and we try to avoid pausing
    // while being in the process of starting it (which can happen when seeking while playing)

    endCurrentSlideTimer:undefined,
    visitedAudioAlerts: [],
    serverTimeOffset: 0,

    getVisitedAlerts() {
        apiService.getBasicSessionProperties() // get server time
            .then(response => {
                if (response.serverTime > 0)
                    this.serverTimeOffset = response.serverTime - new Date().getTime();
            });

        apiService.getSessionProperties() // check if the user has access
            .then(response => {
                if (response && response.user && response.user.audio_recording_popups) {
                    var object = response.user.audio_recording_popups;

                    if (object.show_popup_a ==  true)
                        this.visitedAudioAlerts.push(0);

                    if (object.show_popup_b ==  true)
                        this.visitedAudioAlerts.push(1);

                    if (object.show_popup_c ==  true)
                        this.visitedAudioAlerts.push(2);

                    if (object.show_popup_d ==  true) // video alert
                        this.visitedAudioAlerts.push(3);

                    if (object.show_popup_e ==  true) // Safari alert
                        this.visitedAudioAlerts.push(4);
                }

                if (response && response.user && response.user.allowAnimation == false)
                    animationManager.allowAnimation = false;

                if (response && response.user && (response.user.hasAbpAccess || response.user.organizationunit == 'Vettre skole' || response.user.organizationunit == 'Alfabetplaneten' || response.user.organizationunit == 'Årum skole'))
                    masterUniverseUtils.isSpecialOrganization = true;

                saveManager.init();
            });
    },

    stopRestOfSounds(currentSound) {
        if (currentSound == 'slideSound' || currentSound == 'slideSoundEffect' || currentSound == 'storySound')
            return;

        var audios = ['audioBrowserSound', 'musicSoundId', 'recordedAudio', 'audioEffect'];

        for (var i = 0, len = audios.length; i < len; i++) {
            if (audios[i] != currentSound) {
                this.pauseSound(audios[i]);
            }
        }
    },
    playSound(id, position = -1) {
        var audio = document.getElementById(id);

        if (!audio)
            return;

        if (this.isSoundLoaded(id) && !this.isPlayingAudio(audio)) {
            //this.stopRestOfSounds(id);

            if (position != -1 && audio.currentTime != position)
                audio.currentTime = position;

            audio.play();

            this.updateProperties(id, true);
        }
    },
    pauseSound(id, forcePause = false) {
        var audio = document.getElementById(id);
        var isPlaying;

        if (!audio)
            return;

        if (forcePause)
            isPlaying = true;
        else
            isPlaying = this.isPlayingAudio(audio);

        if (this.isSoundLoaded(id) && this.isPauseAvailable(id) && isPlaying) {
            audio.pause();

            if (forcePause)
                audio.currentTime = 0;

            this.updateProperties(id, false);
        }
    },
    isPlayingAudio(audio) {
        var isPlaying = audio && audio.currentTime > 0 && !audio.paused && !audio.ended && audio.readyState > 2;

        return isPlaying;
    },
    isPlaying(id) {
        var audio = document.getElementById(id);

        return this.isPlayingAudio(audio);
    },
    changeSoundSource(id, url, playOffset = 0) {
        var audio = document.getElementById(id);

        if (!audio || !url)
            return;

        audio.src = videoUtils.checkCacheBreaker(url);

        if (playOffset > 0 && audio.duration > playOffset)
            audio.currentTime = playOffset;

        if (platformDetection.isIOS())
            audio.play();
    },
    updateProperties(id, playValue) {
        switch (id) {
            case 'audioBrowserSound': {
                if (this.updatePropsForContextSound)
                    this.updatePropsForContextSound(playValue);

                if (playValue)
                    this.isPreparingPlayForContextSound = true;

                break;
            }

            case 'musicSoundId': {
                if (this.updatePropsForMusicSound)
                    this.updatePropsForMusicSound(playValue);

                if (playValue)
                    this.isPreparingPlayForMusicSound = true;

                break;
            }

            case 'recordedAudio': {
                if (this.updatePropsForRecordedSound)
                    this.updatePropsForRecordedSound(playValue);

                if (playValue)
                    this.isPreparingPlayForRecordedSound = true;

                break;
            }

            case 'audioEffect': {
                if (this.updateButtonsPlayStatus)
                    this.updateButtonsPlayStatus(playValue, true);

                if (playValue)
                    this.isPreparingPlayForAudioEffect = true;

                break;
            }

            case 'slideSound': {
                if (playValue)
                    this.isPreparingPlayForSlideSound = true;

                break;
            }

            case 'slideSoundEffect': {
                if (playValue)
                    this.isPreparingPlayForSlideSoundEffect = true;

                break;
            }

            case 'storySound': {
                if (playValue)
                    this.isPreparingPlayForStorySound = true;

                break;
            }
        }
    },
    isSoundLoaded(id) {
        var value = false;

        switch (id) {
            case 'audioBrowserSound': {
                value = this.isLoadedContentSound;
                break;
            }

            case 'musicSoundId': {
                value = this.isLoadedMusicSound;
                break;
            }

            case 'recordedAudio': {
                value = this.isLoadedRecordedSound;
                break;
            }

            case 'audioEffect': {
                value = this.isLoadedAudioEffect;
                break;
            }

            case 'slideSound': {
                value = this.isLoadedSlideSound;
                break;
            }

            case 'slideSoundEffect': {
                value = this.isLoadedSlideSoundEffect;
                break;
            }

            case 'storySound': {
                value = this.isLoadedStorySound;
                break;
            }
        }

        return value;
    },
    isPauseAvailable(id) {
        var value = false;

        switch (id) {
            case 'audioBrowserSound': {
                value = !this.isPreparingPlayForContextSound;
                break;
            }

            case 'musicSoundId': {
                value = !this.isPreparingPlayForMusicSound;
                break;
            }

            case 'recordedAudio': {
                value = !this.isPreparingPlayForRecordedSound;
                break;
            }

            case 'audioEffect': {
                value = !this.isPreparingPlayForAudioEffect;
                break;
            }

            case 'slideSound': {
                value = !this.isPreparingPlayForSlideSound;
                break;
            }

            case 'slideSoundEffect': {
                value = !this.isPreparingPlayForSlideSoundEffect;
                break;
            }

            case 'storySound': {
                value = !this.isPreparingPlayForStorySound;
                break;
            }
        }

        return value;
    },

    // ****************************************** Context Sound *********************************************************
    isContentSoundInit: false,
    updatePropsForContextSound: undefined,

    currentSrcForContextSound: undefined,
    isPreparingPlayForContextSound: false,
    isLoadedContentSound: false,

    initContextSound() {
        var audio = document.getElementById('audioBrowserSound');

        if (audio && !this.isContentSoundInit) {
            this.isContentSoundInit = true;

            audio.ondurationchange = this.onContextSoundLoaded.bind(this);
            audio.onended = this.onContextSoundEnded.bind(this);
            audio.onplaying = this.onContextSoundPlay.bind(this);
            audio.onpause = this.onContextSoundPlay.bind(this);
        }
    },
    cleanContextSound() {
        this.isContentSoundInit = false;
        this.updatePropsForContextSound = undefined;
        this.isLoadedContentSound = false;
        this.isPreparingPlayForContextSound = false;
        this.currentSrcForContextSound = undefined;

        var audio = document.getElementById('audioBrowserSound');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onended = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
        }
    },
    playSoundFromUrl(url, updatePropsForContextSound) {
        if (this.updatePropsForContextSound)
            this.updatePropsForContextSound(false);

        this.updatePropsForContextSound = updatePropsForContextSound;

        if (this.currentSrcForContextSound != url) {
            this.currentSrcForContextSound = url;
            this.isLoadedContentSound = false;
            this.isPreparingPlayForContextSound = false;

            this.changeSoundSource('audioBrowserSound', url);
        } else {
            this.playSound('audioBrowserSound');
        }
    },
    onContextSoundPlay() {
        this.isPreparingPlayForContextSound = false;
    },
    onContextSoundEnded() {
        if (this.updatePropsForContextSound)
            this.updatePropsForContextSound(false);
    },
    onContextSoundLoaded() {
        this.isLoadedContentSound = true;
        this.playSound('audioBrowserSound');
    },

    // ****************************************** Music Sound *********************************************************
    updatePropsForMusicSound: undefined,

    currentSrcForMusicSound: undefined,
    isPreparingPlayForMusicSound: false,
    isLoadedMusicSound: false,

    initMusicSound(updatePropsForMusicSound) {
        this.updatePropsForMusicSound = updatePropsForMusicSound;

        var audio = document.getElementById('musicSoundId');

        audio.ondurationchange = this.onMusicSoundLoaded.bind(this);
        audio.onplaying = this.onMusicSoundPlay.bind(this);
        audio.onpause = this.onMusicSoundPlay.bind(this);
        audio.onended = this.onMusicSoundEnded.bind(this);
    },
    cleanMusicSound() {
        this.updatePropsForMusicSound = undefined;
        this.currentSrcForMusicSound = undefined;
        this.isPreparingPlayForMusicSound = false;
        this.isLoadedMusicSound = false;

        var audio = document.getElementById('musicSoundId');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
            audio.onended = undefined;
        }
    },
    updateHrefForMusicSound(url) {
        if (this.currentSrcForMusicSound != url) {
            this.isPreparingPlayForMusicSound = false;
            this.isLoadedMusicSound = false;
        }

        this.currentSrcForMusicSound = url;
    },
    onMusicSoundLoaded() {
        this.isLoadedMusicSound = true;

        if (this.updatePropsForMusicSound)
            this.updatePropsForMusicSound(false);
    },
    onMusicSoundPlay() {
        this.isPreparingPlayForMusicSound = false;
    },
    onMusicSoundEnded() {
        if (this.updatePropsForMusicSound)
            this.updatePropsForMusicSound(false);
    },

    // ******************************************* Recorded Audio ****************************************************
    updatePropsForRecordedSound: undefined,

    currentSrcForRecordedSound: undefined,
    isPreparingPlayForRecordedSound: false,
    isLoadedRecordedSound: false,
    updateSlideDuration: false,

    initRecordedSound(updatePropsForRecordedSound) {
        this.updatePropsForRecordedSound = updatePropsForRecordedSound;

        var audio = document.getElementById('recordedAudio');

        audio.ondurationchange = this.onRecordedSoundLoaded.bind(this);
        audio.onplaying = this.onRecordedSoundPlay.bind(this);
        audio.onpause = this.onRecordedSoundPlay.bind(this);
        audio.onended = this.onRecordedSoundEnded.bind(this);
    },
    cleanRecordingSound() {
        this.updatePropsForRecordedSound = undefined;
        this.currentSrcForRecordedSound = undefined;
        this.isPreparingPlayForRecordedSound = false;
        this.isLoadedRecordedSound = false;

        var audio = document.getElementById('recordedAudio');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
            audio.onended = undefined;
        }
    },
    updateHrefForRecordedSound(url) {
        if (this.currentSrcForRecordedSound != url) {
            this.isPreparingPlayForRecordedSound = false;
            this.isLoadedRecordedSound = false;
        }

        this.currentSrcForRecordedSound = url;
    },
    onRecordedSoundPlay() {
        this.isPreparingPlayForRecordedSound = false;
    },
    onRecordedSoundLoaded() {
        this.isLoadedRecordedSound = true;
        audioUtils.updateSlideDuration = false;
    },
    onRecordedSoundEnded() {
        if (this.updatePropsForRecordedSound)
            this.updatePropsForRecordedSound(false, false, true);
    },

    // ******************************************* Audio Effects ****************************************************
    updateButtonsPlayStatus: undefined,

    currentSrcForAudioEffect: undefined,
    isPreparingPlayForAudioEffect: false,
    isLoadedAudioEffect: false,

    initAudioEffect(updateButtonsPlayStatus) {
        this.updateButtonsPlayStatus = updateButtonsPlayStatus;

        var audio = document.getElementById('audioEffect');

        audio.ondurationchange = this.onAudioEffectLoaded.bind(this);
        audio.onplaying = this.onAudioEffectPlay.bind(this);
        audio.onpause = this.onAudioEffectPlay.bind(this);
        audio.onended = this.onAudioEffectEnded.bind(this);
    },
    cleanAudioEffect() {
        this.updateButtonsPlayStatus = undefined;
        this.currentSrcForAudioEffect = undefined;
        this.isPreparingPlayForAudioEffect = false;
        this.isLoadedAudioEffect = false;

        var audio = document.getElementById('audioEffect');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
            audio.onended = undefined;
        }
    },
    updateHrefForAudioEffect(url) {
        if (this.currentSrcForAudioEffect != url) {
            this.isPreparingPlayForAudioEffect = false;
            this.isLoadedAudioEffect = false;
        }

        this.currentSrcForAudioEffect = url;
    },
    onAudioEffectPlay() {
        this.isPreparingPlayForAudioEffect = false;
    },
    onAudioEffectLoaded() {
        this.isLoadedAudioEffect = true;
    },
    onAudioEffectEnded() {
        if (this.updateButtonsPlayStatus)
            this.updateButtonsPlayStatus(false, true, true);
    },

    // ******************************************* PLAYER -- slide sound ****************************************************
    isPreparingPlayForSlideSound: false,
    isLoadedSlideSound: false,
    currentSrcForSlideSound: undefined,

    initSlideSound() {
        var audio = document.getElementById('slideSound');

        audio.ondurationchange = this.onSlideSoundLoaded.bind(this);
        audio.onplaying = this.onSlideSoundPlay.bind(this);
        audio.onpause = this.onSlideSoundPlay.bind(this);
    },
    cleanSlideSound() {
        this.isPreparingPlayForSlideSound = false;
        this.isLoadedSlideSound = false;
        this.currentSrcForSlideSound = undefined;

        var audio = document.getElementById('slideSound');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
        }
    },
    playSlideSoundFromUrl(url, playOffset = 0) {
        if (this.currentSrcForSlideSound != url) {
            this.currentSrcForSlideSound = url;
            this.isLoadedSlideSound = false;
            this.isPreparingPlayForSlideSound = false;

            this.changeSoundSource('slideSound', url, playOffset);
        } else {
            this.playSound('slideSound', playOffset);
        }
    },
    onSlideSoundLoaded() {
        this.isLoadedSlideSound = true;
        this.playSound('slideSound');
    },
    onSlideSoundPlay() {
        this.isPreparingPlayForSlideSound = false;
    },

    // ******************************************* PLAYER -- slide sound effect ****************************************************
    isPreparingPlayForSlideSoundEffect: false,
    isLoadedSlideSoundEffect: false,
    currentSrcForSlideSoundEffect: undefined,

    initSlideSoundEffect() {
        var audio = document.getElementById('slideSoundEffect');

        audio.ondurationchange = this.onSlideSoundEffectLoaded.bind(this);
        audio.onplaying = this.onSlideSoundEffectPlay.bind(this);
        audio.onpause = this.onSlideSoundEffectPlay.bind(this);
    },
    cleanSlideSoundEffect() {
        this.isPreparingPlayForSlideSoundEffect = false;
        this.isLoadedSlideSoundEffect = false;
        this.currentSrcForSlideSoundEffect = undefined;

        var audio = document.getElementById('slideSoundEffect');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
        }
    },
    playSlideSoundEffectFromUrl(url, playOffset = 0) {
        if (this.currentSrcForSlideSoundEffect != url) {
            this.currentSrcForSlideSoundEffect = url;
            this.isLoadedSlideSoundEffect = false;
            this.isPreparingPlayForSlideSoundEffect = false;

            this.changeSoundSource('slideSoundEffect', url, playOffset);
        } else {
            this.playSound('slideSoundEffect', playOffset);
        }
    },
    onSlideSoundEffectLoaded() {
        this.isLoadedSlideSoundEffect = true;
        this.playSound('slideSoundEffect');
    },
    onSlideSoundEffectPlay() {
        this.isPreparingPlayForSlideSoundEffect = false;
    },

    // ******************************************* PLAYER -- story sound ****************************************************
    isPreparingPlayForStorySound: false,
    isLoadedStorySound: false,
    currentSrcForStorySound: undefined,
    endStorySound: undefined,

    initStorySound(endStorySound) {
        this.endStorySound = endStorySound;

        var audio = document.getElementById('storySound');

        audio.ondurationchange = this.onStorySoundLoaded.bind(this);
        audio.onplaying = this.onStorySoundPlay.bind(this);
        audio.onpause = this.onStorySoundPlay.bind(this);
        audio.onended = this.onStorySoundEnded.bind(this);
    },
    cleanStorySound() {
        this.isPreparingPlayForStorySound = false;
        this.isLoadedStorySound = false;
        this.currentSrcForStorySound = undefined;

        var audio = document.getElementById('storySound');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
            audio.onended = undefined;
        }
    },
    updateHrefForStorySound(url) {
        if (this.currentSrcForStorySound != url) {
            this.isPreparingPlayForStorySound = false;
            this.isLoadedStorySound = false;
        }

        this.currentSrcForStorySound = url;
    },
    playStorySound() {
    },
    onStorySoundLoaded() {
        this.isLoadedStorySound = true;
    },
    onStorySoundPlay() {
        this.isPreparingPlayForStorySound = false;
    },
    onStorySoundEnded() {
        if (this.endStorySound)
            this.endStorySound();
    },

    /********************************** utils ****************/

    hasSlideSound() {
        const state = storeManager.getState();
        const slideSound = state.currentSlide.model.sound;
        const slideSoundWav = state.currentSlide.model.soundWav;

        if ((slideSound && slideSound != '') || (slideSoundWav && slideSoundWav != ''))
            return true;
        else
            return false;
    },
    hasSlideSoundEffect() {
        const state = storeManager.getState();
        const slideSoundEffect = state.currentSlide.model.soundEffect;

        if (slideSoundEffect && slideSoundEffect != '')
            return true;
        else
            return false;
    },
    slideSoundDuration() {
        var audio = document.getElementById('recordedAudio');
        var duration = audio.duration;

        if (duration > 0)
            return duration;
        else
            return 0;
    },
    slideSoundEffectDuration() {
        var audio = document.getElementById('audioEffect');
        var duration = audio.duration;

        if (duration > 0)
            return duration;
        else
            return 0;
    },
    getSoundVolume(id) {
        const state = storeManager.getState();
        var volume;

        if (id == 'recordedAudio' || id == 'slideSound')
            volume = state.currentSlide.model.soundVolume;

        if (id == 'audioEffect' || id == 'slideSoundEffect')
            volume = state.currentSlide.model.soundEffectVolume;

        if (volume)
            volume = parseFloat(volume);

        if (volume >= 0)
            return volume;
        else
            return 0.5;
    },
    setSoundVolume(id) {
        var volume = this.getSoundVolume(id);
        var audio = document.getElementById(id);

        if (audio)
            audio.volume = volume;
    },
    restartAudio(id) {
        var audio = document.getElementById(id);

        if (audio)
            audio.currentTime = 0;
    },
    clearAudioEvents() {
        this.updateButtonsPlayStatus = undefined;

        var audio = document.getElementById('audioEffect');

        if (audio) {
            audio.ondurationchange = undefined;
            audio.onplaying = undefined;
            audio.onpause = undefined;
            audio.onended = undefined;
        }

        this.updatePropsForRecordedSound = undefined;

        var recordedAudio = document.getElementById('recordedAudio');

        if (recordedAudio) {
            recordedAudio.ondurationchange = undefined;
            recordedAudio.onplaying = undefined;
            recordedAudio.onpause = undefined;
            recordedAudio.onended = undefined;
        }
    }
};

export default audioUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AudioUtils.js
 **/